import { render, staticRenderFns } from "./tdsBreakupNewRegimePopup.vue?vue&type=template&id=5f5d5f94&scoped=true"
import script from "./tdsBreakupNewRegimePopup.vue?vue&type=script&lang=js"
export * from "./tdsBreakupNewRegimePopup.vue?vue&type=script&lang=js"
import style0 from "./tdsBreakupNewRegimePopup.vue?vue&type=style&index=0&id=5f5d5f94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5d5f94",
  null
  
)

export default component.exports